import { Components, Theme } from '@mui/material';
import MuiTypography from '../typography/overrides';
import { MuiOutlinedInput, MuiInputBase, MuiInputLabel, MuiTextField } from './Inputs/TextField/overrides';
import MuiButton from './Button/overrides';
import MuiLink from './Link/overrides';
import MuiAutocomplete from './Inputs/Autocomplete/overrides';
import { MuiFormLabel, MuiFormControlLabel, MuiRadio } from './Inputs/RadioGroup/overrides';
import { MuiSwitch } from './Inputs/Switch/overrides';
import { MuiCheckbox } from './Inputs/Checkbox/overrides';
import MuiFormGroup from './Inputs/FormGroup/overrides';
import { MuiFormHelperText } from './Inputs/FormHelperText/overrides';
import MuiSnackbar from './Snackbar/overrides';
import { MuiDialogTitle, MuiDialogActions } from './ModalWindow/overrides';
import MuiTooltip from './Tooltip/overrides';
import MuiChip from './Chip/overrides';
import { MuiTabs, MuiTab } from './TabBar/overrides';
import { MuiCard, MuiCardContent, MuiCardHeader } from './Card/overrides';
import { MuiAlert } from './MessageBox/overrides';
import MuiAvatar from './Avatar/overrides';
import MuiFab from './Fab/overrides';
import MuiListItemButton from './ListItemButton/overrides';
import { MuiAccordion, MuiAccordionDetails, MuiAccordionSummary, MuiAccordionActions } from './Accordion/overrides';
import { MuiPaper } from './Paper/overrides';
import { MuiToggleButton, MuiToggleButtonGroup } from './ToggleButtonGroup/overrides';
import { MuiMenu, MuiMenuItem } from './Menu/overrides';
import MuiBadge from './Badge/overrides';
import { MuiPaginationItem } from './Pagination/overrides';
import MuiDrawer from './Drawer/overrides';
import MuiIcon from './Icon/overrides';
import { MuiStepper, MuiStep, MuiStepLabel } from './Stepper/overrides';
import { MuiStack } from './Stack/overrides';
import { MuiPopper } from './Popper/overrides';
import { MuiModal } from './Modal/overrides';

export default {
  MuiButton,
  MuiToggleButton,
  MuiToggleButtonGroup,
  MuiTypography,
  MuiLink,
  MuiOutlinedInput,
  MuiInputBase,
  MuiTextField,
  MuiInputLabel,
  MuiFormHelperText,
  MuiFormLabel,
  MuiFormControlLabel,
  MuiRadio,
  MuiAutocomplete,
  MuiSwitch,
  MuiFormGroup,
  MuiCheckbox,
  MuiSnackbar,
  MuiDialogTitle,
  MuiDialogActions,
  MuiTooltip,
  MuiChip,
  MuiTabs,
  MuiTab,
  MuiCard,
  MuiCardContent,
  MuiCardHeader,
  MuiFab,
  MuiListItemButton,
  MuiAccordion,
  MuiAccordionDetails,
  MuiAccordionSummary,
  MuiAccordionActions,
  MuiPaper,
  MuiMenu,
  MuiMenuItem,
  MuiBadge,
  MuiPaginationItem,
  MuiAlert,
  MuiDrawer,
  MuiIcon,
  MuiSvgIcon: MuiIcon,
  MuiStepper,
  MuiStep,
  MuiStepLabel,
  MuiAvatar,
  MuiStack,
  MuiPopper,
  MuiModal,
} as Components<Theme>;